/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Case = {
    id?: string;
    /**
     * Case name
     */
    name?: string;
    /**
     * Case image URL
     */
    image?: string;
    /**
     * Preview item image URL
     */
    itemImage?: string;
    /**
     * Case price in cents
     */
    price?: number;
    /**
     * Price in case tokens
     */
    tokenPrice?: number;
    /**
     * Case status: 0=Active, 1=Hidden, 2=Disabled
     */
    status?: Case.status;
    /**
     * Category ID
     */
    caseCategory?: string;
    /**
     * Display order
     */
    order?: number;
    /**
     * Available in arena mode
     */
    isInArena?: boolean;
    /**
     * Case description
     */
    description?: string;
    /**
     * Percentage chance (0-100) for case token drop
     */
    caseTokenDropChance?: number;
    createdAt?: string;
    updatedAt?: string;
};
export namespace Case {
    /**
     * Case status: 0=Active, 1=Hidden, 2=Disabled
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
    }
}

